export const Icons = {
  Challenger: () => (
    // Add this viewBox to element: <Icon name="Challenger" viewBox="0 0 223.67 246.21" />
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <polygon
          className="cls-1"
          points="71.33 145.93 71.33 83.26 0 4.4 0 116.88 45.36 168.9 50.9 168.9 71.33 145.93"
        />
        <polygon
          className="cls-1"
          points="50.9 174.75 45.36 174.75 30.99 200.74 30.99 246.21 71.33 246.21 71.33 200.74 50.9 174.75"
        />
        <polygon
          className="cls-1"
          points="152.13 145.93 152.13 83.26 223.67 4.4 223.67 116.88 178.31 168.9 172.77 168.9 152.13 145.93"
        />
        <polygon
          className="cls-1"
          points="172.33 174.75 177.87 174.75 192.24 200.74 192.24 246.21 152.13 246.21 152.13 200.74 172.33 174.75"
        />
        <polygon
          className="cls-1"
          points="106.78 168.59 115.17 168.59 137.98 145.93 138.05 83.26 111.37 4.09 85.23 83.26 84.76 145.93 106.78 168.59"
        />
        <polygon
          className="cls-1"
          points="114.67 174.75 106.28 174.75 84.47 200.74 84.47 246.21 111.09 246.21 137.69 246.21 137.69 200.74 114.67 174.75"
        />
        <polygon
          className="cls-1"
          points="86.1 54.56 36.75 0 36.75 29.88 78.87 76.45 86.1 54.56"
        />
        <polygon
          className="cls-1"
          points="137.35 54.56 186.7 0 186.7 29.88 144.58 76.45 137.35 54.56"
        />
      </g>
    </g>
  ),
  Masters: () => (
    // Add this viewBox to element: <Icon name="Masters" viewBox="0 0 183.59 232.89" />
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <polygon
          className="cls-1"
          points="52.35 186.41 35.41 186.41 18.87 218.51 18.87 232.89 52.35 232.89 52.35 218.51 52.35 186.41"
        />
        <polygon
          className="cls-1"
          points="98.73 186.41 91.79 186.41 84.85 186.41 68.32 218.51 68.32 232.89 91.79 232.89 115.27 232.89 115.27 218.51 98.73 186.41"
        />
        <polygon
          className="cls-1"
          points="118.45 98.98 91.79 0 65.13 98.98 65.13 157.41 84.85 181.41 98.73 181.41 118.45 157.41 118.45 98.98"
        />
        <polygon
          className="cls-1"
          points="0 15.67 0 142.79 35.41 181.41 52.35 181.41 52.35 98.39 0 15.67"
        />
        <polygon
          className="cls-1"
          points="131.24 186.41 148.18 186.41 164.71 218.51 164.71 232.89 131.24 232.89 131.24 218.51 131.24 186.41"
        />
        <polygon
          className="cls-1"
          points="183.59 15.67 183.59 142.79 148.18 181.41 131.24 181.41 131.24 98.39 183.59 15.67"
        />
      </g>
    </g>
  ),
  Intermediate: () => (
    // Add this viewBox to element: <Icon name="Intermediate" viewBox="0 0 187.75 203.08" />
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <polygon
          className="cls-1"
          points="55.68 203.08 55.68 98.98 0 36.41 0 163.53 35.41 203.08 39.73 203.08 55.68 203.08"
        />
        <polygon
          className="cls-1"
          points="132.08 203.08 132.08 98.98 187.75 36.41 187.75 163.53 152.34 203.08 148.02 203.08 132.08 203.08"
        />
        <polygon
          className="cls-1"
          points="119.69 98.98 93.03 0 66.37 98.98 66.37 139.3 88.53 156.88 98.94 156.88 119.69 139.3 119.69 98.98"
        />
        <polygon
          className="cls-1"
          points="98.94 163.05 88.53 163.07 66.34 188.69 66.37 203.08 93.83 203.02 119.69 202.96 119.66 188.57 98.94 163.05"
        />
      </g>
    </g>
  ),
  Public: () => (
    // Add this viewBox to element: <Icon name="Public" viewBox="0 0 219.02 164.59" />
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <polygon
          className="cls-1"
          points="71.33 164.59 71.33 98.9 0 20.04 0 112.58 45.36 164.59 50.9 164.59 71.33 164.59"
        />
        <polygon
          className="cls-1"
          points="147.69 164.59 147.69 98.9 219.02 20.04 219.02 112.58 173.66 164.59 168.12 164.59 147.69 164.59"
        />
        <polygon
          className="cls-1"
          points="136.66 100 110 0 83.34 100 83.34 164.59 136.66 164.59 136.66 100"
        />
      </g>
    </g>
  ),
} as const;

export type IconNames = keyof typeof Icons;
